<div class="bp-modal-padding-container">
  <h4 class="contacts-list-headline">{{ "recently_used_contacts" | translate }}</h4>
</div>
<ul class="contacts-list bp-modal-padding-container">
  @for (field of recentFields; track field) {
    <li class="contacts-list-item" (click)="selectRecent(field)">
      @if (field?.getType() === 'email') {
        <div
          class="contacts-list-item-image-container-negative email">
          <span class="bpi__icon-{{ field?.getSymbol() | lowercase }}"></span>
        </div>
      } @else {
        <div class="contacts-list-item-image-container-negative asset">
          <span class="{{ asset?.getIconCssName(true) }}"></span>
        </div>
      }
      <div class="contacts-list-item-content">
        <div class="contacts-list-item-name">
          <a href="javascript:" class="color-text">
            {{ getRecentContactDescription(field) | translate: [asset.getSymbol()] }}
          </a>
        </div>
        <bp-info class="mod-overflow">
          {{ field?.getValue() }}
          @if (field?.getDestinationTag()) {
            <span> / {{ field?.getDestinationTag() }}</span>
          }
        </bp-info>
        @if (showDeletedContactName(field)) {
          <bp-info class="contacts-list-item-info">
            {{ getContactByField(field)?.getName() }}
          </bp-info>
        }
        @if (showContactName(field)) {
          <bp-info class="contacts-list-item-info">
            {{ matchingContact(field)[0].getName() }}
          </bp-info>
        }
      </div>
    </li>
  }
</ul>
